
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"63","height":"101","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M61.618 53.43c1.757 2.93.78 6.836-2.149 8.789-.976.586-2.148.781-3.125.781-2.148 0-4.297-.977-5.664-2.93l-5.664-8.984V94.25c0 3.516-2.93 6.25-6.25 6.25-3.516 0-6.25-2.734-6.25-6.25V66.125h-3.125V94.25c0 3.516-2.734 6.25-6.055 6.25-3.515 0-6.25-2.734-6.25-6.25l.196-43.164-5.664 8.984C9.664 63 5.954 63.977 3.024 62.22.094 60.267-.882 56.36.875 53.43l13.868-21.874c2.343-3.711 6.25-6.055 10.546-6.055h11.915c4.296 0 8.203 2.344 10.546 6.055L61.618 53.43zM31.344 19.25c-5.273 0-9.375-4.102-9.375-9.375C21.97 4.797 26.071.5 31.344.5c5.078 0 9.375 4.297 9.375 9.375 0 5.273-4.297 9.375-9.375 9.375z","fill":"#478EF8"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      